export default __webpack_public_path__ + "static/media/v-bar.92f71ef1.svg";